import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { POST_CREATE_GROUP_RESIT_REGISTRATION } from '../../constants/apiUrls';
import {GenericErrorResponse, UuidModel} from '../typings';

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  token?: string;
  onSuccess?: (data: UuidModel) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCreateResitRegistration = ({ token, onSuccess, onError }: Input = {}) => {
  const postCreateResitRegistration = async () => {
    const res = await axiosClient.post<UuidModel>(POST_CREATE_GROUP_RESIT_REGISTRATION(token));
    return res.data;
  };

  return useCustomMutation(postCreateResitRegistration, {
    onSuccess,
    onError,
  });
};
